import { FunctionComponent } from "react";
import { useSelector } from "react-redux";
import ForecastActivity from "rivals/components/pages/Futurecast/ForecastActivity";
import FuturecastLogo from "rivals/components/shared/Icons/FuturecastLogo";
import { getRecentForecasts } from "rivals/redux/futurecast/selectors";
import {
  useIsLgDesktopWidth,
  useIsTouchScreenWidth
} from "rivals/shared/utils/mediaQuery";
import { setData } from "rivals/shared/utils/qa";
import styles from "./RecentForecasts.module.scss";
import strings from "./strings";
import { Props } from "./types";

const RecentForecasts: FunctionComponent<Props> = ({
  lrec,
  lrec2,
  philter = ""
}) => {
  const forecasts = useSelector(getRecentForecasts);
  const { noRecentForecasts, title } = strings;

  if (!forecasts) {
    return <div className={styles.nullState}>{noRecentForecasts}</div>;
  }

  const { isMobileScreen, isTabletScreen } = useIsTouchScreenWidth();
  const isTouchScreen = isMobileScreen || isTabletScreen;

  return (
    <div className={styles.recentForecasts} {...setData(philter)}>
      <div className={styles.leftAdBar}>{useIsLgDesktopWidth() && lrec}</div>
      <div className={styles.forecasts}>
        <div
          className={styles.forecastListHeader}
          {...setData(philter, "title")}
        >
          <FuturecastLogo height={35} variant="dark" />
          <div className={styles.titleText}>{title}</div>
        </div>
        <div className={styles.forecastList} {...setData(philter, "list")}>
          {forecasts.map(forecast => (
            <ForecastActivity
              forecast={forecast}
              key={forecast.id}
              {...setData(philter, `forecast-${forecast.id}`)}
            />
          ))}
          {isTouchScreen && <div className={styles.lrecMobile}>{lrec}</div>}
        </div>
      </div>
      <div className={styles.rightAdBar}>{!isTouchScreen && lrec2}</div>
    </div>
  );
};

export default RecentForecasts;
